import styled, { css } from 'styled-components';
import { palette } from 'styled-tools';

const commonPadding = css`padding: 16px 0;`;

export const CaptionWrapper = styled.div`
    ${commonPadding}
    display: flex;
    flex-direction: column;
    text-align: start;
`;

export const DateWrapper = styled.div`
    ${commonPadding}
    display: flex;
    justify-content: space-between;
    border-top: 1px solid ${palette('gray_opacity_200')};
`;
